import React, { useEffect } from "react";
import {
  FaFlask,
  FaMapMarkerAlt,
  FaCalendarCheck,
  FaFileUpload,
  FaBell,
  FaCreditCard,
  FaHeadset,
} from "react-icons/fa";

/* CARD */
const Card = ({ title, desc, icon }) => (
  <div
    className="
      group
      bg-white/90 backdrop-blur-sm
      border border-red-100
      rounded-2xl
      p-4 md:p-5
      shadow-sm
      hover:shadow-xl
      hover:-translate-y-1
      transition-all duration-300
    "
  >
    {/* ICON */}
    <div
      className="
        w-12 h-12
        rounded-2xl
        bg-gradient-to-br from-red-50 to-red-100
        text-red-600
        flex items-center justify-center
        mb-4
        group-hover:bg-gradient-to-br
        group-hover:from-red-500
        group-hover:to-red-600
        group-hover:text-white
        transition-all duration-300
      "
    >
      {icon}
    </div>

    {/* TITLE */}
    <h2 className="text-base md:text-lg font-semibold text-gray-800 mb-2">
      {title}
    </h2>

    {/* DESC */}
    <p className="text-gray-500 leading-relaxed text-sm">
      {desc}
    </p>
  </div>
);

export default function Services() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const services = [
    {
      icon: <FaMapMarkerAlt size={20} />,
      title: "Lab Discovery",
      desc: "Find nearby diagnostic laboratories based on your healthcare needs.",
    },
    {
      icon: <FaFlask size={20} />,
      title: "Test Booking",
      desc: "Book diagnostic tests and health checkups quickly and easily.",
    },
    {
      icon: <FaCalendarCheck size={20} />,
      title: "Appointment Management",
      desc: "Schedule, reschedule, or cancel appointments anytime.",
    },
    {
      icon: <FaFileUpload size={20} />,
      title: "Upload Reports",
      desc: "Upload prescriptions and access reports securely online.",
    },
    {
      icon: <FaBell size={20} />,
      title: "Notifications",
      desc: "Receive instant updates about bookings and reports.",
    },
    {
      icon: <FaCreditCard size={20} />,
      title: "Secure Payments",
      desc: "Safe and secure payments with trusted payment gateways.",
    },
    {
      icon: <FaHeadset size={20} />,
      title: "Customer Support",
      desc: "Get assistance for bookings, reports, and services.",
    },
  ];

  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-gray-50 via-white to-red-50">

      {/* HERO SECTION */}
      <div
        className="
          w-full
          bg-gradient-to-r from-red-600 to-red-500
          text-white
          py-10 md:py-12
          px-4 md:px-10
          text-center
        "
      >
        <h1 className="text-2xl md:text-4xl font-bold mb-2">
          Our Services
        </h1>

        <p
          className="
            max-w-2xl mx-auto
            text-xs md:text-base
            opacity-90
            leading-relaxed
          "
        >
          MedrphaLab provides healthcare solutions that simplify lab
          discovery, test booking, report management, and healthcare
          access across India.
        </p>
      </div>

      {/* SERVICES */}
      <div className="px-4 md:px-10 py-6 md:py-8">

        {/* GRID */}
        <div className="grid gap-4 md:gap-5 sm:grid-cols-2 lg:grid-cols-3">

          {services.map((service, index) => (
            <Card
              key={index}
              title={service.title}
              desc={service.desc}
              icon={service.icon}
            />
          ))}
        </div>

        {/* EXTRA SECTION */}
        <div
          className="
            mt-6
            bg-white
            border border-red-100
            rounded-2xl
            p-4 md:p-6
            shadow-sm
          "
        >
          <h2 className="text-lg md:text-xl font-semibold text-red-600 mb-4">
            Why Choose MedrphaLab?
          </h2>

          <div className="grid gap-4 md:grid-cols-3">

            {/* BOX */}
            <div
              className="
                bg-gradient-to-br from-red-50 to-white
                border border-red-100
                rounded-2xl
                p-4
                hover:shadow-md
                transition-all duration-300
              "
            >
              <h3 className="font-semibold text-gray-800 mb-1">
                Trusted Labs
              </h3>

              <p className="text-sm text-gray-600 leading-relaxed">
                Verified and reliable diagnostic laboratories across India.
              </p>
            </div>

            {/* BOX */}
            <div
              className="
                bg-gradient-to-br from-red-50 to-white
                border border-red-100
                rounded-2xl
                p-4
                hover:shadow-md
                transition-all duration-300
              "
            >
              <h3 className="font-semibold text-gray-800 mb-1">
                Easy Booking
              </h3>

              <p className="text-sm text-gray-600 leading-relaxed">
                Book tests and healthcare packages within minutes.
              </p>
            </div>

            {/* BOX */}
            <div
              className="
                bg-gradient-to-br from-red-50 to-white
                border border-red-100
                rounded-2xl
                p-4
                hover:shadow-md
                transition-all duration-300
              "
            >
              <h3 className="font-semibold text-gray-800 mb-1">
                Digital Experience
              </h3>

              <p className="text-sm text-gray-600 leading-relaxed">
                Access reports, bookings, and healthcare services digitally.
              </p>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}